export type CaptureRegimeActivation = Readonly<{ year: number; monthIndex: number }>;

// Explicit local review boundary, October 2026 (zero-based month). This is not
// evidence of deployment. At release, set PRODUCTION_CAPTURE_REGIME_ACTIVATION
// to the actual calendar month of activation; never derive it from KPI data.
export const LOCAL_REVIEW_CAPTURE_REGIME_ACTIVATION: CaptureRegimeActivation = Object.freeze({ year: 2026, monthIndex: 9 });
export const PRODUCTION_CAPTURE_REGIME_ACTIVATION: CaptureRegimeActivation | null = null;

export const getCaptureRegimeActivation = (localReview: boolean): CaptureRegimeActivation | null =>
  localReview ? LOCAL_REVIEW_CAPTURE_REGIME_ACTIVATION : PRODUCTION_CAPTURE_REGIME_ACTIVATION;
